import { ProjectActions } from "../../reducers/project/actionsNames";

export default (id: string) => ({
  type: ProjectActions.DeleteCart,
  id,
});
